<template>
  <create-dialog
    width="75%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @handleOpen="handleOpen"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group has-label">
            <label>{{ $t('common_words.company') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-business"
              size="large"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
              @change="handleBusinessChange"
            >
              <el-option
                v-for="option in businesses"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group has-label">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-farm"
              size="large"
              v-model="model.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
              @change="handleFarmChange"
            >
              <el-option
                v-for="option in filteredFarms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group has-label">
            <label>{{ $t('common_words.user') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-user"
              size="large"
              v-model="model.user_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in filteredUsers"
                class="select-primary"
                :value="option.id"
                :label="getUserName(option)"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group has-label">
            <label>{{ $t('devices.device') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-device"
              size="large"
              v-model="model.device_equipment_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in filteredDeviceEquipments"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
          <fg-input
            type="text"
            label="MAC tablet: *"
            v-model="model.tablet_mac"
            name="mac_de_tablet"
            v-validate="modelValidations.tablet_mac"
            :error="getError('mac_de_tablet')"
            placeholder="00:1A:2B:3C:4D:5E"
          ></fg-input>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.device_version')}: *`"
            v-model="model.device_version"
            name="version_de_dispositivo"
            v-validate="modelValidations.device_version"
            :error="getError('version_de_dispositivo')"
            placeholder="..."
          ></fg-input>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="form-group has-label">
            <label>{{ $t('common_words.synchronization_time') }}: *</label>
            <br />
            <el-select
              clearable
              class="select-primary custom-width-select shadow-sm required-sync-time"
              size="large"
              v-model="model.sync_time"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in syncTimeOptions"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="col-12 col-sm-6">
          <label>{{ $t('production.fruit_weight_unit') }}</label>
          <p class="form-control-static mb-0">
            {{ selectedFarmUnitTaraWeight || '-' }}
          </p>
        </div>

        <div class="col-12 col-sm-6">
          <fg-input
            type="number"
            step="0.01"
            :label="`${$t('common_words.weight_threshold_min')}: *`"
            v-model="model.weight_threshold_min"
            name="common_words.weight_threshold_min"
            v-validate="modelValidations.weight_threshold_min"
            :error="getError('common_words.weight_threshold_min', true)"
            min="0"
            placeholder="0.00"
          ></fg-input>
        </div>

        <div class="col-12 col-sm-6">
          <fg-input
            type="number"
            step="0.01"
            :label="`${$t('common_words.weight_threshold_max')}: *`"
            v-model="model.weight_threshold_max"
            name="common_words.weight_threshold_max"
            v-validate="modelValidations.weight_threshold_max"
            :error="getError('common_words.weight_threshold_max')"
            min="0"
            placeholder="0.00"
          ></fg-input>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset, autoSelectElements } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'edit-or-create-scale-configuration',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [MixinDialog, MixinForm, MixinPermissions, MixinValidations],
  data() {
    return {
      businesses: [],
      farms: [],
      deviceEquipments: [],
      users: [],
      disabledField: false,
      model: {
        business_id: null,
        farm_id: null,
        device_equipment_id: null,
        tablet_mac: null,
        device_version: null,
        sync_time: null,
        weight_threshold_min: null,
        weight_threshold_max: null,
        user_id: null,
        route: null,
      },
      modelValidations: {
        tablet_mac: { required: true },
        device_version: { required: true },
        weight_threshold_min: { required: true, decimal: 2, min_value: 0 },
        weight_threshold_max: { required: true, decimal: 2, min_value: 0 },
      },
    };
  },
  computed: {
    syncTimeOptions() {
      return [
        { value: 10, label: '10 min' },
        { value: 15, label: '15 min' },
        { value: 30, label: '30 min' },
        { value: 60, label: '60 min' },
      ];
    },
    filteredFarms() {
      return this.filterByBusiness(this.farms);
    },
    filteredDeviceEquipments() {
      return this.filterByBusiness(this.deviceEquipments);
    },
    filteredUsers() {
      return this.filterByBusiness(this.users);
    },
    selectedFarmUnitTaraWeight() {
      const farm = this.farms.find(
        (item) => Number(item.id) === Number(this.model.farm_id)
      );
      return farm ? farm.unit_tara_weight : null;
    },
  },
  methods: {
    updateDisabledField(value) {
      this.disabledField = value;
    },
    handleOpen() {
      if (!this.model.isEdit) {
        this.model.business_id = autoSelectElements(0, this.businesses);
        this.handleBusinessChange();
      }
    },
    handleBusinessChange() {
      this.model.farm_id = this.getValidSelectedId(
        this.model.farm_id,
        this.filteredFarms
      );
      this.model.device_equipment_id = this.getValidSelectedId(
        this.model.device_equipment_id,
        this.filteredDeviceEquipments
      );
      this.model.user_id = this.getValidSelectedId(
        this.model.user_id,
        this.filteredUsers
      );
    },
    handleFarmChange() {
      this.$forceUpdate();
    },
    getBusinessIds(item) {
      if (!item) return [];
      if (Array.isArray(item.businesses)) {
        return item.businesses.map((business) => Number(business.id));
      }
      if (Array.isArray(item.business_ids)) {
        return item.business_ids.map((id) => Number(id));
      }
      if (Array.isArray(item.business)) {
        return item.business.map((business) => Number(business.id));
      }
      if (isset(item.business_id)) return [Number(item.business_id)];
      return [];
    },
    filterByBusiness(items) {
      if (!isset(this.model.business_id)) return [];
      const businessId = Number(this.model.business_id);
      return items.filter((item) =>
        this.getBusinessIds(item).includes(businessId)
      );
    },
    getValidSelectedId(currentId, items) {
      if (items.some((item) => Number(item.id) === Number(currentId))) {
        return currentId;
      }
      return autoSelectElements(0, items);
    },
    getUserName(user) {
      const names = [user.first_name, user.last_name].filter(Boolean).join(' ');
      return names ? `${names} (${user.username})` : user.username || user.name;
    },
    validateDownloadThreshold() {
      const min = parseFloat(this.model.weight_threshold_min);
      const max = parseFloat(this.model.weight_threshold_max);

      if (min > max) {
        SweetAlert.warning(
          'El umbral de descarga minimo no puede ser mayor que el maximo.'
        );
        return false;
      }

      return true;
    },

    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (!isValid) return false;

        if (!isset(this.model.business_id)) {
          return this.validationInputsRequired('business');
        } else if (!isset(this.model.farm_id)) {
          return this.validationInputsRequired('farm');
        } else if (!isset(this.model.device_equipment_id)) {
          return this.validationInputsRequired('device');
        } else if (!isset(this.model.sync_time)) {
          return this.validationInputsRequired('sync-time');
        } else if (!isset(this.model.user_id)) {
          return this.validationInputsRequired('user');
        } else if (!this.validateDownloadThreshold()) {
          return false;
        }

        this.$emit('addEdit', {
          ...this.model,
          unit_tara_weight: this.selectedFarmUnitTaraWeight,
        });
        return true;
      });
    },
    setEditForm(editForm) {
      this.model = {
        id: editForm.id,
        business_id: editForm.business_id,
        farm_id: editForm.farm_id,
        device_equipment_id:
          editForm.device_equipment_id || editForm.equipment_id,
        tablet_mac: editForm.tablet_mac,
        device_version: editForm.device_version,
        sync_time: editForm.sync_time,
        weight_threshold_min: editForm.weight_threshold_min,
        weight_threshold_max: editForm.weight_threshold_max,
        user_id: editForm.user_id,
        route: editForm.route || null,
        isEdit: true,
      };
      this.errors.clear();
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      this.setEditForm(JSON.parse(sessionStorage.getItem('editForm')));
      sessionStorage.removeItem('editForm');
    }
  },
  created() {
    if (this.isIndex()) {
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('devices/equipments/only'),
        Axios.getMasters('users/indexfield'),
      ])
        .then((response) => {
          const [
            responseBusinesses,
            responseFarms,
            responseDeviceEquipments,
            responseUsers,
          ] = response;

          this.businesses = responseBusinesses.data.data;
          this.farms = responseFarms.data.data;
          this.deviceEquipments = responseDeviceEquipments.data.data;
          this.users = responseUsers.data.data;
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showMessageAccess();
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
  },
};
</script>
